
/**
 * 
 */
export class XmlUtility {

    
    
/**
 * 字符串转json对象
 * 算法摘自网络
 * 
 */
static parseXmlStringToJson(xmlString) {
    let xmlDocument=null;
    

    if (window.DOMParser) { // Standard 
        let parse = new DOMParser();
        xmlDocument = parse.parseFromString(xmlString, "text/xml");
    } else { // IE 
        xmlDocument = new ActiveXObject("Microsoft.XMLDOM");
        xmlDocument.async = "false";
        xmlDocument.loadXML(xmlString);
    }
    let docElement = xmlDocument.documentElement;
    if (!docElement || !docElement.nodeName || docElement.nodeName === "parsererror") {
        return null;
    }

    let retObj = new Object();
    XmlUtility.buildObjectNode(retObj,docElement);

    return retObj;
}
 

static buildObjectNode(cycleOBJ,elNode) {
        
        let nodeAttr = elNode.attributes;
        if (nodeAttr != null) {
            if (nodeAttr.length && cycleOBJ == null) cycleOBJ = new Object;
            for (let i = 0; i < nodeAttr.length; i++) {
                cycleOBJ[nodeAttr[i].name] = nodeAttr[i].value;
            }
        }
        let nodeText = "text";
        if (elNode.text == null) nodeText = "textContent";
        /*NodeList*/
        let nodeChilds = elNode.childNodes;
        if (nodeChilds != null) {
            if (nodeChilds.length && cycleOBJ == null) cycleOBJ = new Object;
            for (let i = 0; i < nodeChilds.length; i++) {
                if (nodeChilds[i].tagName != null) {
                    if (nodeChilds[i].childNodes[0] != null && nodeChilds[i].childNodes.length <= 1 && (nodeChilds[i].childNodes[0].nodeType == 3 || nodeChilds[i].childNodes[0].nodeType == 4)) {
                        if (cycleOBJ[nodeChilds[i].tagName] == null) {
                            cycleOBJ[nodeChilds[i].tagName] = nodeChilds[i][nodeText];
                        } else {
                            if (typeof(cycleOBJ[nodeChilds[i].tagName]) == "object" && cycleOBJ[nodeChilds[i].tagName].length) {
                                cycleOBJ[nodeChilds[i].tagName][cycleOBJ[nodeChilds[i].tagName].length] = nodeChilds[i][nodeText];
                            } else {
                                cycleOBJ[nodeChilds[i].tagName] = [cycleOBJ[nodeChilds[i].tagName]];
                                cycleOBJ[nodeChilds[i].tagName][1] = nodeChilds[i][nodeText];
                            }
                        }
                    } else {
                        if (nodeChilds[i].childNodes.length) {
                            if (cycleOBJ[nodeChilds[i].tagName] == null) {
                                cycleOBJ[nodeChilds[i].tagName] = new Object;
                                XmlUtility.buildObjectNode(cycleOBJ[nodeChilds[i].tagName], nodeChilds[i]);
                            } else {
                                if (cycleOBJ[nodeChilds[i].tagName].length) {
                                    cycleOBJ[nodeChilds[i].tagName][cycleOBJ[nodeChilds[i].tagName].length] = new Object;
                                    XmlUtility.buildObjectNode(cycleOBJ[nodeChilds[i].tagName][cycleOBJ[nodeChilds[i].tagName].length - 1], nodeChilds[i]);
                                } else {
                                    cycleOBJ[nodeChilds[i].tagName] = [cycleOBJ[nodeChilds[i].tagName]];
                                    cycleOBJ[nodeChilds[i].tagName][1] = new Object;
                                    XmlUtility.buildObjectNode(cycleOBJ[nodeChilds[i].tagName][1], nodeChilds[i]);
                                }
                            }
                        } else {
                            cycleOBJ[nodeChilds[i].tagName] = nodeChilds[i][nodeText];
                        }
                    }
                }
            }
        }
    }



}   